import React, { useEffect, useState } from 'react';
import { Form, Select, message } from 'antd';
import { Link } from 'react-router-dom';
import {
  AboutContent,
  Description,
  FormDescription,
  StyledButton,
  StyledFormItem,
  SubHeadContainer,
  SubHeader,
} from './style';
import { useDispatch, useSelector } from 'react-redux';
import {
  creatADgroupConfig,
  getAllDomainGroups,
  getDomainDetails,
  resetProgress,
  setCurrent,
  setStatus,
} from 'redux/slices/setupSlice';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { ContentWrap, FormColWrap, SubHeaderChild } from '../ad_domain/style';
import { FormDivider } from 'pages/settings_page/style';

const AdGroupConfig = () => {
  const dispatch = useDispatch();
  const [disableValue, setDisableValue] = useState(true);
  const { loading, domainData, groupsData } = useSelector((state) => state.setupSlice);

  useEffect(() => {
    dispatch(setStatus('process'));
    dispatch(resetProgress());
    dispatch(getDomainDetails());
  }, []);

  useEffect(() => {
    if (domainData) {
      dispatch(getAllDomainGroups(domainData.fqdn));
    }
  }, [domainData]);

  const onFinish = async (value) => {
    let values;
    if (domainData) {
      values = {
        ...value,
        portalAdmin: value.portalAdmin ? value.portalAdmin : '',
        ouAdmin: value.ouAdmin ? value.ouAdmin : '',
        id: domainData.id,
        domainName: domainData.domainName,
        fqdn: domainData.fqdn,
        ipAddress: domainData.ipAddress,
        isPrimaryDomain: true,
        username: domainData.username,
        password: domainData.password,
        port: domainData.port,
        passwordThreshold: domainData.passwordThreshold,
        securityType: domainData.securityType,
      };
    }
    try {
      const sweetAlert = await dispatch(creatADgroupConfig(values));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        dispatch(setStatus('finish'));
        await message.success('Awesome!! Groups Configured Successfully.');
        dispatch(setCurrent(2));
      } else if (sweetAlert.payload && sweetAlert.payload.status === 400) {
        dispatch(setStatus('error'));
        if (sweetAlert.payload.data) {
          await message.error(sweetAlert.payload.data);
        }
      } else {
        dispatch(setStatus('error'));
        await message.warning('Something Went Wrong Please try again.');
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    }
  };

  return (
    <ContentWrap>
      <SubHeadContainer>
        <SubHeader>Configure Your AD Groups:</SubHeader>
        <SubHeaderChild className='marginLeft'>(You can change it later, from admin interface)</SubHeaderChild>
      </SubHeadContainer>
      <Form name='Configure Your AD Groups' onFinish={onFinish} layout='vertical'>
        <div>
          <FormColWrap>
            <Form.Item
              label='Super Admin Group'
              name='superAdmin'
              rules={[
                {
                  required: true,
                  message: 'Please select your Superadmin!',
                },
              ]}
            >
              <Select allowClear showSearch placeholder='Select A Super Admin' onChange={() => setDisableValue(false)}>
                {groupsData.map((group) => (
                  <Select.Option key={group.distinguishedName} value={group.distinguishedName}>
                    {group.groupName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <FormDescription>
              <FormDivider type='vertical' style={{ top: 0 }} />
              <Description>The users belong to this group will have full access to AD Web Portal.</Description>
            </FormDescription>
          </FormColWrap>
          <FormColWrap>
            <Form.Item
              label='Domain Admin'
              name='portalAdmin'
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Select allowClear showSearch placeholder='Select A Domain Admin'>
                {groupsData.map((group) => (
                  <Select.Option key={group.distinguishedName} value={group.distinguishedName}>
                    {group.groupName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <FormDescription>
              <FormDivider type='vertical' style={{ top: 0 }} />
              <Description>
                The users under this group will have access only to this particular AD Domain. You can also restrict the
                rights from admin settings page.
              </Description>
            </FormDescription>
          </FormColWrap>
          <FormColWrap>
            <Form.Item
              label='Ou Admin'
              name='ouAdmin'
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Select allowClear showSearch placeholder='Select A Ou Admin'>
                {groupsData.map((group) => (
                  <Select.Option key={group.distinguishedName} value={group.distinguishedName}>
                    {group.groupName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <FormDescription>
              <FormDivider type='vertical' style={{ top: 0 }} />
              <Description>
                The users belong to this group can administrate the OU he/she belongs too. You can also restrict the
                rights from admin settings page.
              </Description>
            </FormDescription>
          </FormColWrap>
        </div>
        <FormColWrap>
          <StyledFormItem>
            <StyledButton type='primary' htmlType='submit' disabled={disableValue || loading}>
              {loading ? 'Continue...' : 'Continue'}
            </StyledButton>
          </StyledFormItem>
          <Form.Item></Form.Item>
        </FormColWrap>
      </Form>
      <AboutContent>
        Know more about Admin roles? <Link style={{ textDecoration: 'unset', color: '#0c5992' }}>Click Here{'>>'}</Link>
      </AboutContent>
    </ContentWrap>
  );
};
export default AdGroupConfig;
